module.exports = __webpack_public_path__ + "static/media/scoli-adams-3f.fee5ca6d.png";